const joi = require('joi');

const schema = joi.object({
  version: joi.string()
    .min(3)
    .max(10)
    .required(),
}).options({ abortEarly: false, stripUnknown: true });

export default schema;
